// Display-only mirror of server/lib/tiers.js's address-plan pricing and add-on rules
// (TIER_PRICES, ADDON_PRICES, isAddonEligible, ADDONS_REQUIRING_FORWARDING_ADDRESS). The server
// is authoritative and re-validates every charge — but update prices/eligibility in both files
// together so what customers see matches what they're billed.

export const ADDRESS_PLANS = {
  virtual_address: {
    label:    'Virtual Business Address',
    price:    45,
    userType: 'member_virtual_address',
    addons:   ['mail_forwarding', 'mail_dashboard'],
  },
  professional_address: {
    label:    'Professional Mailbox',
    price:    55,
    userType: 'member_professional_address',
    addons:   ['mail_forwarding', 'room_discount', 'mail_dashboard'],
  },
}

export const ADDONS = {
  mail_forwarding: {
    label:       'Mail Forwarding',
    price:       10,
    description: 'Forward your mail to an address you provide instead of holding it for pickup. Postage/handling per piece billed separately.',
  },
  room_discount: {
    label:       'Room Discount',
    price:       25,
    description: 'Book private offices and the conference room at the discounted member rate.',
  },
  mail_dashboard: {
    label:       'Mail Portal',
    price:       25,
    description: 'See every piece of mail online the moment it arrives, in your My Mail tab — choose forward, scan, or shred with one click. Requires a forwarding address on file.',
  },
}

// Add-ons that need a forwarding address + the Mail Handling Agreement and typed signature.
export const ADDONS_REQUIRING_FORWARDING_ADDRESS = ['mail_forwarding', 'mail_dashboard']

const PRODUCT_BY_USER_TYPE = Object.fromEntries(
  Object.entries(ADDRESS_PLANS).map(([product, plan]) => [plan.userType, product])
)

// Eligible add-on keys for a user_type (dashboards) — [] for anyone who isn't on an address plan.
export function eligibleAddonsForUserType(userType) {
  return ADDRESS_PLANS[PRODUCT_BY_USER_TYPE[userType]]?.addons ?? []
}

export function addressPlanTotal(product, addonKeys) {
  return ADDRESS_PLANS[product].price + addonKeys.reduce((sum, key) => sum + (ADDONS[key]?.price ?? 0), 0)
}
